import React from "react";
import PrimeButton from "./PrimeButton";
/**
 * 
 * @param {*} lineHeight for line hight of paragraph
 * @param Align For Text Algin
 * @param position for justify and algin
 * @param btnAppear for disappear button or not
 * @param bgColor for brightness and gradient
 * @param widthToggle for content width in about and service
 * @param imgSrc image path
 * @param title of title of hero Section
 * @param content for content of hero Section 
 * @returns 
 */
export default function HeroSectionPrime({
  lineHeight,
  Align,
  position,
  btnAppear = false,
  imgSrc,
  bgColor,
  title,
  content,
  widthToggle,
  Height="h-screen",
}) {
  return (
    <>
      <section className={`${Height} w-full relative flex flex-col justify-center items-center z-40`}>
        <div
          className={`w-4/5 text-white flex flex-col ${
            position === "s"
              ? "justify-start items-start"
              : "justify-center items-center"
          } gap-5 ${Align}`}
        >
          <h2 className={`hookrideFont  md:w-[60%]`}>{title}</h2>
          <p className={`text-sm md:text-lg ${widthToggle?"md:w-[40%]":"md:w-[60%]"} ${lineHeight}`}>
            {content}
          </p>
          {btnAppear && <PrimeButton />}
        </div>
        <div className={`w-full h-full  absolute -z-10 top-0 after:absolute after:w-full after:h-full ${bgColor==="gradient"?"after:bg-gradient-to-r bg-gradient-to-r  after:from-[#005CB9] after:to-blue-500/30 after:opacity-80":"brightness-50"}   after:top-0 after:left-0`}>
          <img
            src={imgSrc}
            alt="About Hero Section"
            className="w-full h-full object-cover"
            loading="lazy"
            
          />
        </div>
      </section>
    </>
  );
}
